var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadModularplug = function SvgFadModularplug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 226c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 218c-49.706 0-90-40.294-90-90s40.294-90 90-90 90 40.294 90 90-40.294 90-90 90z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 197c-38.108 0-69-30.668-69-68.5S89.892 60 128 60c38.108 0 69 30.668 69 68.5S166.108 197 128 197z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 190.71c-34.22 0-61.96-27.54-61.96-61.511 0-33.971 27.74-61.51 61.96-61.51s61.96 27.539 61.96 61.51-27.74 61.51-61.96 61.51z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 170c-23.196 0-42-18.804-42-42s18.804-42 42-42 42 18.804 42 42-18.804 42-42 42z",
    fill: "#000"
  }))));
};
export { SvgFadModularplug as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-modularplug.ce02163a.svg";